import { FC, ReactElement } from 'react';
import { isPhone } from 'base/utils/client';
import { Drawer } from '@base/lib/Drawer';
import { ThemeModal } from '@base/lib/ThemeModal';

type IProps = {
    className?: string;
    children: ReactElement;
    visible: boolean;
    onClose: () => void;
    width: number;
    title: string;
};

export const NotifyPopup: FC<IProps> = props => {
    const {
        className,
        children,
        visible,
        onClose,
        width,
        title,
    } = props;

    return isPhone ? (
        <Drawer
            className={className}
            title={title}
            open={visible}
            onClose={onClose}
            body={children}
        />
    ) : (
        <ThemeModal
            className={className}
            width={width}
            open={visible}
            onCancel={onClose}
        >
            {children}
        </ThemeModal>
    )
};
